import { render, staticRenderFns } from "./AttemptTargetsV2.vue?vue&type=template&id=586bbef8&scoped=true&lang=pug&"
import script from "./AttemptTargetsV2.vue?vue&type=script&lang=js&"
export * from "./AttemptTargetsV2.vue?vue&type=script&lang=js&"
import style0 from "./AttemptTargetsV2.vue?vue&type=style&index=0&id=586bbef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586bbef8",
  null
  
)

export default component.exports